import React from "react";
import translations from "translations";

const { time: timeTexts, terms: termTexts } = translations.globals;

export function makeId(length: number) {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function useGetRandomId(length: number = 4) {
  return React.useMemo(() => makeId(length), []);
}

export function debug(name: string, ...input: any) {
  if (process.env.NODE_ENV === "development") console.log(`[${name}]`, ...input);
}

export function parseIntsFromString(string: string, separator: string = ","): number[] {
  return string.split(separator).reduce<number[]>((res, current) => {
    const id = parseInt(current);
    if (isNaN(id)) return res;
    res.push(id);
    return res;
  }, []);
}

export const getSelectDateOptions = () => {
  return [
    { value: "0", label: termTexts.all },
    { value: "24", label: timeTexts.last24Hours },
    { value: "72", label: timeTexts.last3Days },
    { value: "168", label: timeTexts.lastWeek },
    { value: "210", label: timeTexts.lastMonth },
    { value: "8760", label: timeTexts.lastYear },
  ];
};

export const getSelectBooleanOptions = () => {
  return [
    { value: "", label: termTexts.all },
    { value: "true", label: termTexts.yes },
    { value: "false", label: termTexts.no },
  ];
};
